import { render, staticRenderFns } from "./SurveyManagementNewQuestionButton.vue?vue&type=template&id=3ba338fc&scoped=true&"
import script from "./SurveyManagementNewQuestionButton.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementNewQuestionButton.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementNewQuestionButton.vue?vue&type=style&index=0&id=3ba338fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba338fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba338fc')) {
      api.createRecord('3ba338fc', component.options)
    } else {
      api.reload('3ba338fc', component.options)
    }
    module.hot.accept("./SurveyManagementNewQuestionButton.vue?vue&type=template&id=3ba338fc&scoped=true&", function () {
      api.rerender('3ba338fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/SurveyManagementNewQuestionButton.vue"
export default component.exports